import {
  createCategory,
  deleteCategory,
  editCategory,
  getCategories,
  getFeaturedCategories,
  toggleCategoryStatus,
  getProducts,
  getFeaturedProducts,
  getProduct,
  createProduct,
  editProduct,
  deleteProduct,
  getLowStockProducts,
  getSimilarProducts,
  getProductDimensions,
  saveProductDimensions,
  deleteProductDimensions,
} from "./asyncThunks";

// Categories builders
export const getCategoriesBuilder = (builder) => {
  builder.addCase(getCategories.pending, (state) => {
    state.categories.loading = true;
    state.categories.error = null;
  });
  builder.addCase(getCategories.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = data;
    state.categories.loading = false;
  });
  builder.addCase(getCategories.rejected, (state, action) => {
    state.categories.loading = false;
    state.categories.error = action.error.message;
  });
};

export const getFeaturedCategoriesBuilder = (builder) => {
  builder.addCase(getFeaturedCategories.pending, (state) => {
    state.featuredCategories.loading = true;
    state.featuredCategories.error = null;
  });
  builder.addCase(getFeaturedCategories.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.featuredCategories.data = data;
    state.featuredCategories.loading = false;
  });
  builder.addCase(getFeaturedCategories.rejected, (state, action) => {
    state.featuredCategories.loading = false;
    state.featuredCategories.error = action.error.message;
  });
};

export const createCategoryBuilder = (builder) => {
  builder.addCase(createCategory.pending, (state) => {
    state.categories.createLoading = true;
    state.categories.error = null;
  });
  builder.addCase(createCategory.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = [...state.categories.data, data];
    state.categories.createLoading = false;
  });
  builder.addCase(createCategory.rejected, (state, action) => {
    state.categories.createLoading = false;
    state.categories.error = action.error.message;
  });
};

export const deleteCategoryBuilder = (builder) => {
  builder.addCase(deleteCategory.pending, (state) => {
    state.categories.deleteLoading = true;
    state.categories.error = null;
  });
  builder.addCase(deleteCategory.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = state.categories.data.filter(
      (ctg) => ctg.id !== data.id
    );
    state.categories.deleteLoading = false;
  });
  builder.addCase(deleteCategory.rejected, (state, action) => {
    state.categories.deleteLoading = false;
    state.categories.error = action.error.message;
  });
};

export const toggleCategoryStatusBuilder = (builder) => {
  builder.addCase(toggleCategoryStatus.pending, (state) => {
    state.categories.toggleLoading = true;
    state.categories.error = null;
  });
  builder.addCase(toggleCategoryStatus.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = state.categories.data.map((ctg) =>
      ctg.id === data.id ? data : ctg
    );
    state.categories.toggleLoading = false;
  });
  builder.addCase(toggleCategoryStatus.rejected, (state, action) => {
    state.categories.toggleLoading = false;
    state.categories.error = action.error.message;
  });
};

export const editCategoryBuilder = (builder) => {
  builder.addCase(editCategory.pending, (state) => {
    state.categories.editLoading = true;
    state.categories.error = null;
  });
  builder.addCase(editCategory.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.categories.data = state.categories.data.map((ctg) =>
      ctg.id === data.id ? data : ctg
    );
    state.categories.editLoading = false;
  });
  builder.addCase(editCategory.rejected, (state, action) => {
    state.categories.editLoading = false;
    state.categories.error = action.error.message;
  });
};

// Products builders
export const getProductsBuilder = (builder) => {
  builder.addCase(getProducts.pending, (state) => {
    state.products.loading = true;
    state.products.error = null;
  });
  builder.addCase(getProducts.fulfilled, (state, { payload }) => {
    const { data, total, page, perPage, maxReached } = payload;
    state.products.data = data;
    state.products.total = total;
    state.products.page = page;
    state.products.perPage = perPage;
    state.products.maxReached = maxReached;
    state.products.loading = false;
  });
  builder.addCase(getProducts.rejected, (state, action) => {
    state.products.loading = false;
    state.products.error = action.error.message;
  });
};

export const getFeaturedProductsBuilder = (builder) => {
  builder.addCase(getFeaturedProducts.pending, (state) => {
    state.featuredProducts.loading = true;
    state.featuredProducts.error = null;
  });
  builder.addCase(getFeaturedProducts.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.featuredProducts.data = data;
    state.featuredProducts.loading = false;
  });
  builder.addCase(getFeaturedProducts.rejected, (state, action) => {
    state.featuredProducts.loading = false;
    state.featuredProducts.error = action.error.message;
  });
};

export const getProductBuilder = (builder) => {
  builder.addCase(getProduct.pending, (state) => {
    state.selectedProduct.loading = true;
    state.selectedProduct.error = null;
  });
  builder.addCase(getProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.selectedProduct.data = data;
    state.selectedProduct.loading = false;
  });
  builder.addCase(getProduct.rejected, (state, action) => {
    state.selectedProduct.loading = false;
    state.selectedProduct.error = action.error.message;
  });
};

export const createProductBuilder = (builder) => {
  builder.addCase(createProduct.pending, (state) => {
    state.products.createLoading = true;
    state.products.error = null;
  });
  builder.addCase(createProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.products.data = [data, ...state.products.data];
    state.products.createLoading = false;
  });
  builder.addCase(createProduct.rejected, (state, action) => {
    state.products.createLoading = false;
    state.products.error = action.error.message;
  });
};

export const editProductBuilder = (builder) => {
  builder.addCase(editProduct.pending, (state) => {
    state.products.editLoading = true;
    state.products.error = null;
  });
  builder.addCase(editProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.products.data = state.products.data.map((product) =>
      product.id === data.id ? data : product
    );
    // Also update selectedProduct if it's the same product
    if (state.selectedProduct.data?.id === data.id) {
      state.selectedProduct.data = data;
    }
    state.products.editLoading = false;
  });
  builder.addCase(editProduct.rejected, (state, action) => {
    state.products.editLoading = false;
    state.products.error = action.error.message;
  });
};

export const deleteProductBuilder = (builder) => {
  builder.addCase(deleteProduct.pending, (state) => {
    state.products.deleteLoading = true;
    state.products.error = null;
  });
  builder.addCase(deleteProduct.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.products.data = state.products.data.filter(
      (product) => product.id !== data.id
    );
    // Clear selectedProduct if it was the deleted product
    if (state.selectedProduct.data?.id === data.id) {
      state.selectedProduct.data = null;
    }
    state.products.deleteLoading = false;
  });
  builder.addCase(deleteProduct.rejected, (state, action) => {
    state.products.deleteLoading = false;
    state.products.error = action.error.message;
  });
};

export const getLowStockProductsBuilder = (builder) => {
  builder.addCase(getLowStockProducts.pending, (state) => {
    state.lowStockProducts.loading = true;
    state.lowStockProducts.error = null;
  });
  builder.addCase(getLowStockProducts.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.lowStockProducts.data = data;
    state.lowStockProducts.loading = false;
  });
  builder.addCase(getLowStockProducts.rejected, (state, action) => {
    state.lowStockProducts.loading = false;
    state.lowStockProducts.error = action.error.message;
  });
};

export const getSimilarProductsBuilder = (builder) => {
  builder.addCase(getSimilarProducts.pending, (state) => {
    state.similarProducts.loading = true;
    state.similarProducts.error = null;
  });
  builder.addCase(getSimilarProducts.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.similarProducts.data = data;
    state.similarProducts.loading = false;
  });
  builder.addCase(getSimilarProducts.rejected, (state, action) => {
    state.similarProducts.loading = false;
    state.similarProducts.error = action.error.message;
  });
};

// Product Dimensions builders
export const getProductDimensionsBuilder = (builder) => {
  builder.addCase(getProductDimensions.pending, (state) => {
    state.productDimensions.loading = true;
    state.productDimensions.error = null;
  });
  builder.addCase(getProductDimensions.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.productDimensions.data = data;
    state.productDimensions.loading = false;
  });
  builder.addCase(getProductDimensions.rejected, (state, action) => {
    state.productDimensions.loading = false;
    state.productDimensions.error = action.error.message;
  });
};

export const saveProductDimensionsBuilder = (builder) => {
  builder.addCase(saveProductDimensions.pending, (state) => {
    state.productDimensions.saveLoading = true;
    state.productDimensions.error = null;
  });
  builder.addCase(saveProductDimensions.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.productDimensions.data = data;
    state.productDimensions.saveLoading = false;
  });
  builder.addCase(saveProductDimensions.rejected, (state, action) => {
    state.productDimensions.saveLoading = false;
    state.productDimensions.error = action.error.message;
  });
};

export const deleteProductDimensionsBuilder = (builder) => {
  builder.addCase(deleteProductDimensions.pending, (state) => {
    state.productDimensions.deleteLoading = true;
    state.productDimensions.error = null;
  });
  builder.addCase(deleteProductDimensions.fulfilled, (state) => {
    state.productDimensions.data = null;
    state.productDimensions.deleteLoading = false;
  });
  builder.addCase(deleteProductDimensions.rejected, (state, action) => {
    state.productDimensions.deleteLoading = false;
    state.productDimensions.error = action.error.message;
  });
};
